export const environment = {
  production: true,
  buildId: '3574044437422761',
  configFile: 'config.json',
};
